import dayjs from 'dayjs';

export default {
  name: 'CancelComfirmation',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    order: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    open: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    onConfirm() {
      this.$emit('confirm');
    },
    humanizeTime(time) {
      return dayjs(time).format('YYYY-MM-DD HH:mm');
    },
  },
};
